import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c473ea8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Questions-content" }
const _hoisted_2 = { class: "Questions-content-title h1" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Questions-img" }, [
  /*#__PURE__*/_createElementVNode("picture", null, [
    /*#__PURE__*/_createElementVNode("source", { srcset: "/images/home/register.png 1x, /images/home/register@2x.png 2x" }),
    /*#__PURE__*/_createElementVNode("img", {
      src: "/images/home/register.png",
      alt: "register home"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineByLine = _resolveComponent("LineByLine")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_RoundSection = _resolveComponent("RoundSection")!
  const _component_AppearObject = _resolveComponent("AppearObject")!

  return (_openBlock(), _createBlock(_component_AppearObject, {
    class: _normalizeClass(`Questions Questions--${_ctx.backgroundColor}`),
    "data-scroll-section": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_RoundSection, { class: "Questions-inner grid padded" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_2, [
                _createVNode(_component_LineByLine, { innerHTML: _ctx.title }, null, 8, ["innerHTML"])
              ]),
              _createElementVNode("p", {
                class: "Questions-content-text text-lg",
                innerHTML: _ctx.description
              }, null, 8, _hoisted_3),
              _createVNode(_component_ButtonHover, {
                onClick: _ctx.onClickCta,
                to: _ctx.cta.to,
                class: "Questions-content-link button button--white"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.cta.label), 1)
                ]),
                _: 1
              }, 8, ["onClick", "to"])
            ])
          ]),
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}